export default {
    submittedForApproval: 'Submitted for Approval',
    resultsDefaultPageSize: 20,
    collegeTeamEmail: 'college@universaltennis.com',
    highSchoolTeamEmail: 'hsteam@universaltennis.com',
    clubsEmail: 'am@universaltennis.com',
    hsGraduationRollover: { month: 7, day: 15 },
};
